<template>
     <PageFull header="Все транзакции" type="white" :fullwidth="true" :nopadding="false">
        <template v-slot:body>
            <div class="w-full px-3">  
                <TransList v-if='trans && trans.length > 0' 
                    :transactions="trans" :total="totalRecords" :account_id="account_id" :loading="loading"
                    @filter="setFilter" @lazyParams="setParams" :defaultParams="lazyParams"/>
                <span v-else-if="trans && trans.length === 0">
                    Нет транзакций
                </span>
                <Skeleton height="2rem" v-else />
            </div>
        </template>
    </PageFull>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import PageFull from '@/components/sides/PageFull.vue'
import TransList from '@/components/admin/transaction/list.vue'

export default {
    data() {
        return {
            account_id: null,
            trans: [],
            loading: false,
            lazyParams: {
                first: 0,
                rows: 20,
                sort: null,
                sortField: null,
                sortOrder: null,
                filters: {},
            },
            totalRecords: 0,
        }
    },
    components: {
        PageFull,
        TransList
    },
    methods: {
        setFilter(filters) {
            this.lazyParams.filters = filters
            this.loadTrans();
        },
        setParams(params) {
            this.lazyParams = params
            this.loadTrans()
        },
        async loadTrans() {
            this.loading = true
            try {
                window.scrollTo({ top: 0, behavior: 'smooth' })
                const trans = await this.connect.trans_list(this.lazyParams.rows, this.lazyParams.first, this.lazyParams.filters, this.lazyParams.sort).then(res => res)
                if (trans.result && trans.data) {
                    if (trans.result && trans.data.length > 0) this.trans = trans.data
                    else this.trans = []
                }
                this.totalRecords = (trans.total) ? trans.total : 0
            } catch (e) {
                console.log(e)
            }
            this.loading = false
        },
        get_format_amount(value, currency) {
            if(!value) return 0
            return this.helper.format_amount(value, currency)
        },
        get_short_id(value){
            return this.helper.get_short_id(value)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        formatDate(value) {
            return this.helper.format_date(value)
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        const operation_id = (this.$route.query.operation_id) ? this.$route.query.operation_id : null
        if(operation_id) this.lazyParams.filters.operation_id = {value: operation_id, matchMode: 'contains'}

        try{
            await this.loadTrans()
        } catch (e) {
            console.log(e)
        }
    },
    
}
</script>